var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"custom-checkbox",class:{ checked: _vm.checked },attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":() => _vm.$emit('checked', !_vm.checked)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked),expression:"checked"}],staticClass:"checked-state"},[_c('i',{staticClass:"fa fa-check"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }